module.exports = __webpack_public_path__ + "assets/webgl/art_069_L0.5ab4445e.jpg";